import React, { useEffect, useMemo, useState } from "react";
import "../../bases-estaleiro/BasesEstaleiroPage.css";
import "./BasesCimPage.css";
import MotivosViaBase from "./motivos/via/MotivosViaBase";
import MotivosVagoesBase from "./motivos/vagoes/MotivosVagoesBase";
import MotivosToBase from "./motivos/to/MotivosToBase";
import MotivosLocomotivasBase from "./motivos/locomotivas/MotivosLocomotivasBase";
import PostosOrigemBase from "./postos-origem/PostosOrigemBase";
import SecaoBloqueioBase from "./secao-bloqueio/SecaoBloqueioBase";
import TiposOperacaoBase from "./tipos-operacao/TiposOperacaoBase";

const HOME_VIEW_ID = "home_bases_cim";
const STORAGE_KEY = "pai4.basesCim.moduloSelecionado";

const MODULO_ICONS = {
  home_bases_cim: "HM",
  motivos_via: "MV",
  motivos_vagoes: "VG",
  motivos_to: "TO",
  motivos_locomotivas: "LO",
  postos_origem: "PO",
  tipos_operacao: "TP",
  secaodebloqueio: "SB",
};

const MODULOS_BASE = [
  {
    id: "motivos_via",
    titulo: "Motivos VIA",
    descricao: "Cadastro base dos motivos usados pelas interdições de VIA do CIM.",
    ativo: true,
  },
  {
    id: "motivos_vagoes",
    titulo: "Motivos VAGÕES",
    descricao: "Cadastro base dos motivos usados pelas interdições de VAGÕES do CIM.",
    ativo: true,
  },
  {
    id: "motivos_to",
    titulo: "Motivos TO",
    descricao: "Cadastro base dos motivos usados pelas interdições de TO do CIM.",
    ativo: true,
  },
  {
    id: "motivos_locomotivas",
    titulo: "Motivos LOCOMOTIVAS",
    descricao: "Cadastro base dos motivos usados pelas interdições de LOCOMOTIVAS do CIM.",
    ativo: true,
  },
  {
    id: "postos_origem",
    titulo: "Postos de Origem",
    descricao: "Cadastro base dos postos de origem usados nas interdicoes operacionais do CIM.",
    ativo: true,
  },
  {
    id: "tipos_operacao",
    titulo: "Tipos de Operação",
    descricao: "Cadastro base dos tipos de operação usados nas interdições operacionais do CIM.",
    ativo: true,
  },
  {
    id: "secaodebloqueio",
    titulo: "Seção de Bloqueio",
    descricao: "Cadastro base da seção de bloqueio com SUB e faixa de KM vinculadas ao CIM.",
    ativo: true,
  },
];

function getSavedModule() {
  try {
    const saved = window.localStorage.getItem(STORAGE_KEY);
    if (!saved) return HOME_VIEW_ID;
    if (saved === HOME_VIEW_ID) return HOME_VIEW_ID;
    return MODULOS_BASE.some((modulo) => modulo.id === saved) ?saved : HOME_VIEW_ID;
  } catch {
    return HOME_VIEW_ID;
  }
}

function ModuloButton({ id, titulo, descricao, ativo = true, selected, onClick }) {
  return (
    <button
      type="button"
      className={`bes-modulo-btn ${selected ?"is-selected" : ""}`}
      onClick={onClick}
    >
      <span className="bes-modulo-icon" aria-hidden="true">
        {MODULO_ICONS[id] || "*"}
      </span>
      <span className="bes-modulo-main">
        <span className="bes-modulo-title">{titulo}</span>
        <span className="bes-modulo-desc">{descricao}</span>
        {!ativo ?<span className="bes-chip">Em implantação</span> : null}
      </span>
      <span className="bes-modulo-arrow" aria-hidden="true">
        ›
      </span>
    </button>
  );
}

function BasesCimHome({ onSelectModulo }) {
  const totalAtivos = MODULOS_BASE.filter((modulo) => modulo.ativo).length;

  return (
    <section className="bes-home-panel bes-home">
      <div className="bes-home-hero bcim-hero">
        <div className="bes-home-hero-content">
          <div className="bes-home-hero-text">
            <span className="bes-home-pill">Bases do CIM</span>
            <h3>Central de manutenção das bases do CIM</h3>
            <p>
              Concentre aqui os cadastros que vão sustentar as telas do CIM, como
              relacionamento de seção de bloqueio, faixa de KM, SUB e motivos por tipo de
              interdição.
            </p>
            <div className="bes-home-hero-kpis">
              <div className="bes-home-hero-kpi">
                <span className="bes-home-hero-kpi-value">{MODULOS_BASE.length}</span>
                <span className="bes-home-hero-kpi-label">Módulos</span>
                <span className="bes-home-hero-kpi-note">
                  Catálogo centralizado das bases do CIM
                </span>
              </div>
              <div className="bes-home-hero-kpi">
                <span className="bes-home-hero-kpi-value">{totalAtivos}</span>
                <span className="bes-home-hero-kpi-label">Ativos</span>
                <span className="bes-home-hero-kpi-note">
                  Prontos para apoiar as telas do CIM
                </span>
              </div>
              <div className="bes-home-hero-kpi">
                <span className="bes-home-hero-kpi-value">4</span>
                <span className="bes-home-hero-kpi-label">Tipos</span>
                <span className="bes-home-hero-kpi-note">
                  VIA, VAGÕES, TO e LOCOMOTIVAS já separados em código
                </span>
              </div>
            </div>
          </div>

          <div className="bes-home-hero-panel">
            <span className="bes-home-panel-title">Acesso rápido</span>
            <div className="bes-home-panel-grid">
              {MODULOS_BASE.map((modulo, index) => (
                <button
                  key={modulo.id}
                  type="button"
                  className="bes-home-panel-card"
                  onClick={() => onSelectModulo(modulo.id)}
                >
                  <span className="bes-home-panel-value">{index + 1}</span>
                  <span className="bes-home-panel-label">{modulo.titulo}</span>
                </button>
              ))}
            </div>
            <span className="bes-home-panel-foot">
              Selecione um módulo na lateral para abrir a base correspondente.
            </span>
          </div>
        </div>
      </div>

      <div className="bes-home-section">
        <div className="bes-home-section-head">
          <div>
            <h4>Módulos disponíveis</h4>
            <p>As bases abaixo serão usadas pelas telas operacionais do CIM.</p>
          </div>
        </div>

        <div className="bes-home-modules-list">
          {MODULOS_BASE.map((modulo) => (
            <button
              key={modulo.id}
              type="button"
              className="bes-home-module-item"
              onClick={() => onSelectModulo(modulo.id)}
            >
              <span className="bes-home-module-icon" aria-hidden="true">
                {MODULO_ICONS[modulo.id] || "*"}
              </span>
              <span className="bes-home-module-copy">
                <strong>{modulo.titulo}</strong>
                <p>{modulo.descricao}</p>
              </span>
              <span className={`bes-home-status ${modulo.ativo ?"is-active" : "is-pending"}`}>
                {modulo.ativo ?"Ativo" : "Pendente"}
              </span>
            </button>
          ))}
        </div>
      </div>
    </section>
  );
}

export default function BasesCimPage({ onBack }) {
  const [moduloSelecionado, setModuloSelecionado] = useState(getSavedModule);

  useEffect(() => {
    try {
      window.localStorage.setItem(STORAGE_KEY, moduloSelecionado);
    } catch {}
  }, [moduloSelecionado]);

  const moduloAtivo = useMemo(
    () => MODULOS_BASE.find((modulo) => modulo.id === moduloSelecionado) || null,
    [moduloSelecionado]
  );

  function goBack() {
    if (onBack) onBack();
    else if (window.history.length > 1) window.history.back();
    else window.location.href = "/";
  }

  return (
    <main className="bes-page">
      <div className="bes-root">
        <aside className="bes-sidebar">
          <button type="button" className="bes-back" onClick={goBack}>
            Menu Principal
          </button>

          <section className="bes-side-card">
            <h3>Módulos</h3>
            <div className="bes-modulos">
              <ModuloButton
                id={HOME_VIEW_ID}
                titulo="Home das Bases"
                descricao="Visão geral dos módulos de cadastro do CIM."
                selected={moduloSelecionado === HOME_VIEW_ID}
                onClick={() => setModuloSelecionado(HOME_VIEW_ID)}
              />

              {MODULOS_BASE.map((modulo) => (
                <ModuloButton
                  key={modulo.id}
                  id={modulo.id}
                  titulo={modulo.titulo}
                  descricao={modulo.descricao}
                  ativo={modulo.ativo}
                  selected={moduloSelecionado === modulo.id}
                  onClick={() => setModuloSelecionado(modulo.id)}
                />
              ))}
            </div>
          </section>
        </aside>

        <section className="bes-content">
          <header className="bes-header">
            <div className="bes-header-copy">
              <h1>Bases do CIM</h1>
              <p className="bes-subtitle">{moduloAtivo?.titulo || "Home das Bases"}</p>
            </div>
          </header>

          <div className="bes-module-shell">
            {moduloSelecionado === HOME_VIEW_ID ?(
              <BasesCimHome onSelectModulo={setModuloSelecionado} />
            ) : null}

            {moduloAtivo?.id === "motivos_via" ?<MotivosViaBase /> : null}
            {moduloAtivo?.id === "motivos_vagoes" ?<MotivosVagoesBase /> : null}
            {moduloAtivo?.id === "motivos_to" ?<MotivosToBase /> : null}
            {moduloAtivo?.id === "motivos_locomotivas" ?<MotivosLocomotivasBase /> : null}
            {moduloAtivo?.id === "postos_origem" ?<PostosOrigemBase /> : null}
            {moduloAtivo?.id === "tipos_operacao" ?<TiposOperacaoBase /> : null}
            {moduloAtivo?.id === "secaodebloqueio" ?<SecaoBloqueioBase /> : null}
          </div>
        </section>
      </div>
    </main>
  );
}
